import {DestroyRef, inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {AuthService, LoggedUser, MenuService, Portal, PortalService} from "../../../backend";
import {environment} from "../../../environments/environment";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root'
})
export class PortalEnvironmentService {

  #destroyRef = inject(DestroyRef);

  _portal: Portal | undefined;
  _user: LoggedUser | undefined;

  portal$: ReplaySubject<Portal> = new ReplaySubject<Portal>(1);
  //portalId$: ReplaySubject<number> = new ReplaySubject<number>(1);

  user$: ReplaySubject<LoggedUser> = new ReplaySubject<LoggedUser>(1);

  initialized = false;

  SERVER_URL: string = environment.backendPath;
  SWIPE_AUTOPLAY_DELAY: number = 10000;

  constructor(private authRest: AuthService, private portalService: PortalService, private menuService: MenuService) {
    this.portal$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(value => {
        this._portal = value;
        this.initialized = true;
      })
    this.reloadUser();
  }

  findPortalByUrl(): Observable<any> {
    let url = location.href
    return this.portalService.findPortalbyUrl(url);
  }


  reloadUser() {
    this.authRest.getLoggedOrEmptyUser()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: (value: LoggedUser) => {
          if (value.id === undefined || value.id === null) {
            return;
          }
          this.user$.next(value);
        },
        error: (error: any) => {
          this.user$.error(error);
        }
      })
    this.user$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(value => {
        this._user = value;
      })
  }

  public getPortal(): any {
    return this._portal;
  }

  public isPortalExist(): boolean {
    if (this._portal === undefined) {
      return false;
    }
    return true;
  }

  public findLanguage(value: Portal) {
    if (value === undefined || value.languages === undefined) {
      return "en";
    }
    let languages = value.languages.filter(x => x.defaultLanguage);
    if (languages.length > 0) {
      return languages[0].lang;
    }
    return "en";
  }

  logoutUser() {
    this._user = undefined;
    this.authRest.logout()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        error: (error: any) => {
          this.user$.error(error);
        }
      })
  }

  authenticated() {
    return this._user !== undefined;
  }
}
